import { render, staticRenderFns } from "./CardsProductsPerforado.vue?vue&type=template&id=11c8a0c5&scoped=true&"
import script from "./CardsProductsPerforado.vue?vue&type=script&lang=js&"
export * from "./CardsProductsPerforado.vue?vue&type=script&lang=js&"
import style0 from "./CardsProductsPerforado.vue?vue&type=style&index=0&id=11c8a0c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c8a0c5",
  null
  
)

export default component.exports